export { GMAIL, OUTLOOK365 } from './EmailClientTypes';
export const IMAP = 'IMAP';